import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import $ from "jquery";

import { getUrlParameter, sendRequest } from './global.js';
import Storage from './Storage.js';

import LoginForm from './LoginForm.js';
import AdminMenu from './AdminMenu.js';
import ObjectListView from './ObjectListView.js';
import ObjectEditView from './ObjectEditView.js';
import SortableView from './SortableView.js';
import RequestView from './RequestView.js';
import GraphsView from './GraphsView.js';
import SimpleRequestsView from './SimpleRequestsView.js';

var MODES = ["none", "list", "view", "edit", "create", "simple-requests", "request", "sortable", "graphs"];

class AdminPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getStateForLocation = (location) => {
    location = location || window.location.search;
    var id = parseInt(getUrlParameter("id", location), 10) || null;
    var page = getUrlParameter("page", location);
    if (!Storage.getConfig(page)) {
      page = null;
      id = null;
    }
    var object = id ? {id: id} : {};
    var mode = this.modeForPage(page, object);
    var state = {
      page: page,
      mode: mode,
      target: object,
    };
    return state;
  }

  getMenuItems = (adminUser, adminGroup) => {
    var items = [];
    var configKeys = Storage.getConfigKeys();
    for (let i = 0; i < configKeys.length; i++) {
      let configObject = Storage.getConfig(configKeys[i]);
      if (!configObject.config.adminGroup || adminGroup) {
        items.push(configKeys[i]);
      }
      if (configObject.config.adminUser) {
        configObject.config.preset = !adminUser;
        Storage.setConfig(configKeys[i], configObject);
      }
    }
    return items;
  }

  getDefaultPage = () => {
    return "mailings";
  }

  getInitialState = () => {
    return {
      logged: localStorage.getItem("access_token") != null,
      page: null,
      mode: "none",
      menuItems: [],
      user: null,
    };
  }

  onLogin = () => {
    this.setState({logged: true});
    this.getUsersRole();
  }

  onLogout = (e) => {
    localStorage.clear();
    window.location.href = "/";
  }

  modeForPage = (page, object) => {
    if (!page) {
      return "none";
    }
    var mode = Storage.getConfig(page).config.type;
    if (mode && $.inArray(mode, MODES)) {
      return Storage.getConfig(page).config.type;
    }
    if (object && object.id) {
      return "view";
    } else {
      return "list";
    }
  }

  getUsersRole = () => {
    sendRequest({
      method: "users/current",
      type: "GET",
      success: (data) => {
        let adminUser = data.role === "admin";
        let adminGroup = data.user_group && data.user_group.admin === true;
        let menuItems = this.getMenuItems(adminUser, adminGroup);
        let state = this.getStateForLocation();
        state.user = data;
        state.menuItems = menuItems;
        if (!state.page || $.inArray(state.page, menuItems) < 0) {
          state.page = this.getDefaultPage();
          state.mode = this.modeForPage(state.page);
          // change url string
          window.history.replaceState({}, "", "?" + $.param({page: state.page}));
        }
        this.setState(state);
      },
      error: (xhr, status, err) => {
      }
    });
  }
  
  componentDidMount = () => {
    if (this.state.logged) {
      this.getUsersRole();
    }

    $(document).on("changePage", (e, page, object, submode) => {
      var mode = submode || this.modeForPage(page, object);
      var params = {page: page};
      if (object && object.id) {
        params.id = object.id;
      }
      window.history.pushState({}, "", "?" + $.param(params));
      this.setState({page: page, mode: mode, target: object});
    });

    $(document).on("openPage", (e, page, object, submode) => {
      var params = {page: page};
      if (object && object.id) {
        params.id = object.id;
      }
      window.open("/?" + $.param(params));
    });

    window.onpopstate = (event) => {
      var state = this.getStateForLocation(document.location.search);
      if ($.inArray(state.page, this.state.menuItems) < 0) {
        state.page = this.state.menuItems[0];
        state.mode = this.modeForPage(state.page);
        // change url string
        window.history.replaceState({}, "", "?" + $.param({page: state.page}));
      }
      this.setState(state);
    };
    
  }

  render = () => {
    if (!this.state.logged) {
      return (
        <LoginForm onLogin={this.onLogin}/>
      )
    }

    var pageView = null;
    if (this.state.mode === "graphs") {
      pageView = <GraphsView configKey={this.state.page} key={this.state.page}/>
    } else if (this.state.mode === "sortable") {
      pageView = <SortableView configKey={this.state.page} key={this.state.page}/>
    } else if (this.state.mode === "request") {
      pageView = <RequestView configKey={this.state.page} key={this.state.page}/>
    } else if (this.state.mode === "simple-requests") {
      pageView = <SimpleRequestsView configKey={this.state.page} key={this.state.page}/>
    } else if (this.state.mode === "list") {
      pageView = <ObjectListView configKey={this.state.page} key={this.state.page} user={this.state.user}/>
    } else if (this.state.mode !== "none") {
      pageView = 
        <ObjectEditView 
          configKey={this.state.page}
          edit={this.state.mode === "edit"}
          object={this.state.target}
          user={this.state.user}
        />
    }

    return(
      <div>
        <AdminMenu
          onLogout={this.onLogout}
          selected={this.state.page}
          items={this.state.menuItems}
        />
        <ReactCSSTransitionGroup
          transitionName="content"
          transitionEnterTimeout={400}
          transitionLeaveTimeout={400}
        >{pageView}
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

export default AdminPanel;



// WEBPACK FOOTER //
// ./src/AdminPanel.js